import AIcon from '@/components/A/AIcon/AIcon'
import { useEventListener } from 'ahooks'
import { useEffect, useRef, useState } from 'react'
// import Player from 'xgplayer/es/player'
import styles from './VideoVolumeBar.module.less'



interface Props {
  // videoInstance: Player | null
  barHeight: number
  onVolumeChange?: (rate: number) => void
}

function VideoVolumeBar(props: Props) {
  const BAR_LINE_HEIGHT = 155
  const BAR_HEIGHT = props.barHeight
  const defaultVolumnRate = 0.2
  const [volumeRate, setVolumeRate] = useState(0)
  const [isMoving, setIsMoving] = useState(false)
  const lineRef = useRef<HTMLDivElement>(null)
  const barRef = useRef<HTMLDivElement>(null)

  const rangedRate = (rate: number) => {
    if (rate < 0) {
      return 0
    }
    if (rate > 1) {
      return 1
    }
    return rate
  }

  const handleVolumnBtnClick = () => {
    if (volumeRate === 0) {
      setVolumeRate(defaultVolumnRate)
    } else {
      setVolumeRate(0)
    }
  }

  const handleVolumeBarMouseDown = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    const { bottom } = lineRef.current!.getBoundingClientRect()
    const y = bottom - e.clientY
    const rate = y / BAR_LINE_HEIGHT
    setIsMoving(true)
    setVolumeRate(rangedRate(rate))
  }

  const handleVolumeBarMouseMove = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (!isMoving) { return }
    const { bottom } = lineRef.current!.getBoundingClientRect()
    const y = bottom - e.clientY
    const rate = y / BAR_LINE_HEIGHT
    setVolumeRate(rangedRate(rate))
  }

  const handleVolumeBarMouseUp = () => {
    setIsMoving(false)
  }

  const handleVolumeBarMouseLeave = () => {
    setIsMoving(false)
  }

  useEventListener('mousemove', handleVolumeBarMouseMove, { target: barRef.current })
  useEventListener('mousedown', handleVolumeBarMouseDown, { target: barRef.current })
  useEventListener('mouseup', handleVolumeBarMouseUp, { target: barRef.current })
  useEventListener('mouseleave', handleVolumeBarMouseLeave, { target: barRef.current })


  useEffect(() => {
    if (props.onVolumeChange) {
      props.onVolumeChange(volumeRate)
    }
  }, [volumeRate])

  // useEffect(() => {
  //   if (!props.videoInstance) { return }
  //   props.videoInstance.volume = volumeRate
  // }, [props.videoInstance, volumeRate])

  return <div className={styles.videoVolumeBar}>
    <span className={styles.volumeBtn} onClick={handleVolumnBtnClick}>
      <AIcon width={BAR_HEIGHT * 0.5} height={BAR_HEIGHT * 0.5} type={volumeRate > 0 ? 'icon-fill-global_Sound' : "icon-fill-global_Sound2"}></AIcon>
    </span>
    <div className={styles.volumeBar} ref={barRef}>
      <div className={styles.volumeBarLine} style={{ height: BAR_LINE_HEIGHT }} ref={lineRef} >
        <div className={styles.volumeBarProgress} style={{ height: BAR_LINE_HEIGHT * volumeRate }}></div>
        <div className={styles.volumeBarDot} style={{ bottom: BAR_LINE_HEIGHT * volumeRate }}></div>
      </div>
    </div>
  </div>

}

export default VideoVolumeBar

